import {CostEventsDataGridApi} from "src/api/generated/erp/common/costEvents/api/costEventsDataGridApi.ts";
import {CostEventObjectRef} from "src/api/generated/erp/common/costEvents/model/costEventObjectRef.ts";
import {CostEventsDataGridBase} from "src/components/views/erp/common/costEvents/CostEventsDataGridBase.tsx";
import {
    SendCostEventsOfObjectByEmailButton
} from "src/components/views/erp/common/costEvents/SendCostEventsOfObjectByEmailButton.tsx";

export interface CostEventsOfObjectDataGridProps {
    objectRef: CostEventObjectRef;
    costEventPriceListId: number;
}

export const CostEventsOfObjectDataGrid = ({
                                               objectRef,
                                               costEventPriceListId,
                                           }: CostEventsOfObjectDataGridProps) => {
    return (
        <CostEventsDataGridBase
            fetchData={({dataModelRequest}) =>
                CostEventsDataGridApi.getDataGridData({
                    objectRef,
                    dataModelRequest,
                })
            }
            initialParams={{}}
            insert={{
                type: "enabled",
                newEventObjectRef: objectRef,
                newEventPriceListId: costEventPriceListId,
            }}
            actionBarMenuComponents={() => [
                <SendCostEventsOfObjectByEmailButton
                    key={"sendCostEventsToEmail"}
                    objectRef={objectRef}/>
            ]}
            gridId={"A5FA2F0C5AE1EA16"}
        />
    );
};
